import { get } from "../../../Services/http";
import { catchError } from "../../../Actions/Error.action";

export const HISTORY_BLOCK_RECEIVE = "HISTORY_BLOCK_RECEIVE";
export const HISTORY_BLOCK_ERROR = 'HISTORY_BLOCK_ERROR';

export const fetchHistoryModel = (id) => (dispatch) => {
    return get('/api/historyBlock/' + id)
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(ex => dispatch(catchError(ex, error => setError(error))));
}

export const receive = result => ({
    type: HISTORY_BLOCK_RECEIVE,
    payload: result
})

export const setError = error => ({
    type: HISTORY_BLOCK_ERROR,
    payload: {
        error,
    },
})